import React, { useContext } from 'react';
import { Icon, UtilsBlock } from '@hz-design-system/web-ui';
import { Trans, useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { getFormattedNumber } from '@ecg-marktplaats/aurora-js-formatters';

import EnvironmentContext from '../../../../contexts/EnvironmentContext';
import PopupLink from '../PopupLink/PopupLink';

import { TListing } from 'types/TListing';

import Classes from './Report.scss';

type TReportProps = {
  itemId: TListing['itemId'];
  stats: TListing['stats'];
};

const Report = ({ itemId, stats }: TReportProps) => {
  const { t, date } = useI18nContext();
  const { favoritedCount, viewCount, since } = stats;
  const { userDetails: { isAdOwner = false } = {} } = useContext(EnvironmentContext);

  return (
    <div
      className={`${Classes.root} hz-Page-section`}
      aria-label={`${t('stats.viewed', { viewCount })} ${t('stats.favorited', { favoritedCount })} ${t('stats.since').concat(date(new Date(since), "D MMM 'YY, HH:mm"))}`}
    >
      <div className={Classes.stats}>
        <div className={Classes.stat}>
          <Icon name="eye-open" />
          <Trans className={Classes.label} i18nKey="adInfo.viewed" viewCount={getFormattedNumber(viewCount)} />
        </div>

        <div className={Classes.stat}>
          <Icon name="heart" />
          <Trans
            className={Classes.label}
            i18nKey="adInfo.favorited"
            favoritedCount={getFormattedNumber(favoritedCount)}
          />
        </div>

        <div className={Classes.stat} title={date(new Date(since), "D MMM 'YY, HH:mm")}>
          <Icon name="calendar" />
          <Trans className={Classes.label} i18nKey="adInfo.since" date={date(new Date(since), "D MMM 'YY")} />
        </div>
      </div>

      <div className={Classes.adInfo}>
        <UtilsBlock color="text-secondary" as="span">
          {t('listing.itemId', { itemId })}
        </UtilsBlock>
        {!isAdOwner && <PopupLink itemId={itemId} />}
      </div>
    </div>
  );
};

export default Report;
